import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Wallet } from 'lucide-react';
import { formatCurrency } from '@/lib/formatUtils';
import type { CashPosition } from '@/hooks/useDashboardInsights';

interface CashPositionCardProps {
  cashPosition: CashPosition;
  insight?: string;
}

export const CashPositionCard: React.FC<CashPositionCardProps> = ({
  cashPosition,
  insight,
}) => {
  return (
    <Card className="bg-card h-full">
      <CardContent className="p-6">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <Wallet className="h-4 w-4 text-muted-foreground" />
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Cash Position
          </span>
        </div>

        {/* Current Balance */}
        <div className="mb-4">
          <p className="text-sm text-muted-foreground mb-1">Current Balance</p>
          <p className="text-4xl font-bold tracking-tight font-mono">
            {formatCurrency(cashPosition.currentBalance)}
          </p>
        </div>

        <div className="border-t border-border mb-4" />

        {/* Safe to Spend */}
        <div className="mb-4">
          <p className="text-sm text-muted-foreground mb-1">Safe to Spend This Week</p>
          <p className="text-3xl font-bold tracking-tight font-mono">
            {formatCurrency(cashPosition.safeToSpend)}
          </p>
        </div>

        {/* Inventory Spend Target */}
        <div className="mb-3">
          <p className="text-xs text-muted-foreground mb-1">Inventory Spend Target</p>
          <p className="text-xl font-semibold font-mono">
            {formatCurrency(cashPosition.inventorySpendTarget)}
          </p>
        </div>

        {/* Insight */}
        {insight && (
          <p className="text-sm text-muted-foreground">
            {insight}
          </p>
        )}
      </CardContent>
    </Card>
  );
};
